import React, { useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useRouteMatch } from 'react-router-dom'

// styles
import { WrapHeader } from './index.styles'

// images
import LogoFacepay from '../../../assets/images/LogoFacepay'
import IcLogOut from '../../../assets/images/IcLogOut'
import IcLogOutWhite from '../../../assets/images/IcLogOutWhite'
import IcCloseOutlineWhite from '../../../assets/images/IcCloseOutlineWhite'
import IcUserHeader from '../../../assets/images/IcUserHeader'

//hook
import { useOnClickOutside } from '../../../hook/useClickOutside'

//action
import { logoutAction } from '../../../redux/login/action'

// component
import Portal from '../../Control/Portal'
import PopupChangePass from './PopupChangePass'

// constant
import { MAIN } from '../../../constant/path'
import { env, WEE_ENV } from '../../../constant/environmentTypes';
import { CONNECTED, DISCONNECTED, TERMINATED, UNLINKED } from '../../../constant/keys'


const Header = (props) => {

    const dispatch = useDispatch()
    const history = useHistory()
    const refDropdown = useRef(null)

    const [isShow, setIsShow] = useState(false)
    const [isShowPopupChangePass, setIsShowPopupChangePass] = useState(false)

    const { userName, listFirebase } = useSelector(state => ({
        userName: state.loginReducer.dataLogin.fullname,
        listFirebase: state.deviceReducer.listDevicesByAdmin.listFirebase,
    }))

    const totalDisconnectDivce = listFirebase?.reduce((total, item) => {
        return item.status === DISCONNECTED || item.status === UNLINKED || item.status === TERMINATED ? total + 1 : total
    }, 0)
    
    useOnClickOutside(refDropdown, () => {
        setIsShow(false)
    })

    const _handleLogOut = () => {
        dispatch(logoutAction(history, true))
    }

    return (
        <WrapHeader {...props} ref={refDropdown} isWarning={!!totalDisconnectDivce}>
            <div className='wrap-header'>
                <Link to={`/${MAIN}`} className="logo-facepay">
                    <LogoFacepay />
                </Link>
                {
                    totalDisconnectDivce > 0 &&
                    <div className="device-disconnected">
                        <IcCloseOutlineWhite />
                        <span>{totalDisconnectDivce} thiết bị hiện đang mất kết nối</span>
                    </div>
                }
                <div className="user">
                    <p className="user_name">{userName}</p>
                    <IcUserHeader className="ic-user" onClick={() => env !== WEE_ENV && setIsShowPopupChangePass(true)} />
                    {
                        isShowPopupChangePass &&
                        <Portal>
                            <PopupChangePass
                                setIsShowPopupChangePass={setIsShowPopupChangePass}
                                userName={userName}
                            />
                        </Portal>
                    }
                    {/* <IcAvatar className="ic-avatar"/> */}
                    <IcLogOut className="ic-logout" onClick={() => setIsShow(!isShow)} />
                    {
                        isShow &&
                        <div className="popup-logout">
                            <p className="tit-popup">Đăng xuất</p>
                            <p className="des-popup">Bạn có muốn đăng xuất tài khoản khỏi ứng dụng?</p>
                            <div className="button" onClick={_handleLogOut}>
                                <IcLogOutWhite />
                                <p className="text-popup">Đăng xuất</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </WrapHeader>
    )
}

export default Header
